import $ from "jquery";
import * as bootbox from "bootbox";
import moment from "moment";
import Seed from "DMS/Seed/All";
import { escapeSelector } from "DMS/Utils/lib";
import { encodeParam, decodeParam } from "DMS/Utils/parameter";
import * as checkFeatures from "DMS/Utils/checkFeatures";
import parseNumber from "DMS/Utils/number";
import { openModalIframe } from "DMS/Utils/modal";
import { kendoNotify } from "../Controllers/kendoController";
var OnClickEnabled = true;
/**
 * Appeler une action SMaint
 * @param {int} numaction Numero de l'action
 * @param {array} param Tableau de paramètres
 * @param {array} paramui Tableau de champs de filtre
 * (input, select...)
 * @param {type} input
 * @param {bool} modeDebug Mode debug. Ouvrze le Manage.
 * @param {bool} forceNoReload Supprime le raffraichissement
 * de l'onglet
 * @param {type} forceNoRead
 * @param {bool} isImpr Check if it is impr button
 * @param {} selectedElem
 * @param {Boolean} isFromForm Check if it's called from a form
 */
export function process(numaction, param, paramui, input, modeDebug, forceNoReload, forceNoRead, isImpr, selectedElem, isFromForm, event) {
    if (typeof event === "undefined")
        event = false;
    else if (typeof event.currentTarget.childNodes[0].className !== 'undefined')
        if (event.currentTarget.childNodes[0].className.startsWith('fa fa-plus'))
            event = true;
        else
            event = false;
    else
        event = false;
    if (typeof isImpr === "undefined")
        isImpr = false;
    if (!isFromForm)
        if (selectedElem)
            Seed.Tab.SetElementPosition(selectedElem);
    if (OnClickEnabled === false)
        return Promise.resolve(0);
    if (!modeDebug)
        modeDebug = false;
    var sImport = "";
    var champRequisOk = true;
    if (param) {
        var paramLength = param.length;
        for (var i = 0; i < paramLength; i++)
            sImport += "&" + param[i][0] + "=" + encodeURIComponent(param[i][1]);
    }
    if (paramui) {
        var paramuiLength = paramui.length;
        var firstElementRequiered = "";
        for (var i = 0; i < paramuiLength; i++) {
            var paramuiEscaped = escapeSelector(paramui[i][1]);
            var uielement = $("#tab_" + Seed.Tab.cTab.attr("id")).find('#' + paramuiEscaped);
            if (uielement.length === 0)
                uielement = $("#tab_" + Seed.Tab.cTab.attr("id")).find('[id^=' + paramuiEscaped + '_]');
            if (uielement.length !== 0) {
                if ((uielement.val() === "") && (paramui[i][2] === "1") && isImpr === false) {
                    var parentGroup = $(uielement).parents('div.search-block');
                    $(parentGroup).addClass('has-error');
                    champRequisOk = false;
                    if (!firstElementRequiered)
                        firstElementRequiered = uielement;
                }
                var value = uielement.val();
                if ($(uielement).hasClass('SM-datepicker') && value.length !== 0)
                    value = moment.utc(value, 'L').toISOString();
                sImport += "&" + paramui[i][0] + "=" + encodeParam(value);
            }
        }
    }
    if (champRequisOk === false && event === true) {
        // Champ requis non renseigné
        Seed.Tab.GetFrame().find('.collapse').collapse('show');
        var box = bootbox.alert(MSG_CHAMP_REQUIS);
        // Focus sur le 1er champ à renseigner
        box.on('hidden.bs.modal', function () {
            firstElementRequiered.focus();
        });
        return Promise.resolve(0);
    }
    else {
        // Zone en création
        var searchform = Seed.Tab.GetFrame().find('div#recherche');
        searchform.find('.has-error').removeClass('has-error');
    }
    if (modeDebug) {
        var MngPath;
        if (moduleType === "ServiceMaint")
            MngPath = "../Manage/";
        else if (moduleType === "ePortail")
            MngPath = "../../EServices/Manage/";
        var svgwindow = window.open(MngPath + "index.php?"
            + "draw=yes"
            + "&action=" + numaction
            + sImport
            + "&moduleType=" + moduleType, "name", "menubar=no,resizable=yes,scrollbars=yes,"
            + "toolbar=no,width=400,height=400");
    }
    return processAction("action=" + numaction + sImport, input, forceNoReload, forceNoRead);
}
/**
 * Lancer une action
 * @param {string} sendrequest arguments à passer
 * @param {type} input
 * @param {bool} forceNoReload
 * @param {bool} forceNoRead
 * @returns {undefined}
 */
export function processAction(sendrequest, input, forceNoReload, forceNoRead) {
    var promise1 = new Promise(function (resolve) {
        var url = "Process.php";
        if ((typeof moduleType !== "undefined")
            && (moduleType === "ePortail")) {
            url = "../../EServices/source/" + url;
        }
        else if (moduleType === "Localisation") {
            url = "../../" + url;
        }
        Seed.Ajax.Get({
            url: url + "?" + sendrequest + "&moduleType=" + moduleType,
            async: true,
            success: function (Response) {
                if (forceNoReload) {
                    Response = Response.replace('Seed.Tab.Reload();', '');
                }
                // Eviter refresh inutile car on a fait autre chose
                // comme ouvrir un formulaire
                if (Response.includes("require(")) {
                    Response = Response.replace('Seed.Tab.Reload();', '');
                }
                // Eviter double refresh
                Response = Response.replace('Seed.Tab.Reload();Seed.Tab.Reload();', 'Seed.Tab.Reload();');
                eval(Response);
                resolve();
            }
        });
    });
    return promise1;
}
/**
 * @param {string} pNomTable Nom de la table concernée par l'update
 * @param {int} pNomChampIndex Nom du champ index
 * @param {int} pIndex valeur de l'index
 * @param {string} pNomChamp Nom du champ à update
 * @param {mixed} pNouvelleValeur Valeur saisie par l'utilisateur
 * @param {array} pImport ???
 * @param {boolean} forceReload ???
 * @param {string} origine Contient l'origine de l'utilisateur (genre fr-FR)
 * @param {string} typechamp contient le type de champ
 * @param param_multiselect_insert
 * @param updateOrigin Where does the update come from (list | form)
 * @param {boolean} validateAllFields Do we need to validate all the form fields ?
 * @returns {object}
 */
export async function processUpdate(pNomTable, pNomChampIndex, pIndex, pNomChamp, pNouvelleValeur, pImport, forceReload, origine, typechamp, param_multiselect_insert = false, updateOrigin = "form", secondPkNameForDefaultValue = '', param_multiselect_default = '') {
    // Vérification du type d'entrée, si c'est un nombre
    // sans lettre on passe dans la fonction ParseNumber
    // Le champ origine a été rajouté à la fonction ProcessUpdate
    var numberSupport = checkFeatures.checkInput('number') && checkFeatures.isSmallDevice();
    if (!numberSupport && (typechamp === 'nombre')) {
        //On envoit la valeur et l'origine du user dans la fonction
        // pour la formatter
        pNouvelleValeur = parseNumber(pNouvelleValeur, origine);
    }
    else if (typechamp === 'date') {
        if (pNouvelleValeur) {
            var myDate = moment.utc(pNouvelleValeur, "L");
            if (myDate.isValid() === false) {
                myDate = moment.utc(pNouvelleValeur, "YYYY-MM-DD");
            }
            pNouvelleValeur = myDate.toISOString();
        }
    }
    else if (typechamp === 'dateheure') {
        var myDate = moment.utc(pNouvelleValeur, "L LT");
        if (myDate.isValid() === false) {
            pNouvelleValeur = pNouvelleValeur.replace('T', ' ');
            myDate = moment.utc(pNouvelleValeur, "YYYY-MM-DD HH:mm");
        }
        if (pNouvelleValeur) {
            pNouvelleValeur = myDate.toISOString();
        }
    }
    else if (typechamp === 'heure' || typechamp === 'duration') {
        if (pNouvelleValeur) {
            pNouvelleValeur = moment.utc(pNouvelleValeur, "LT")
                .toISOString();
            pNouvelleValeur = moment.utc(pNouvelleValeur).format('HH:mm:ss');
        }
    }
    const send = "nomtable=" + pNomTable
        + "&nomchampindex=" + pNomChampIndex
        + "&bbmindex=" + pIndex
        + "&nomchamp=" + pNomChamp
        + "&nouvellevaleur=" + encodeURIComponent(pNouvelleValeur)
        + "&param_multiselect_insert=" + param_multiselect_insert
        + "&updateOrigin=" + updateOrigin
        + "&secondPkNameForDefaultValue=" + secondPkNameForDefaultValue
        + "&param_multiselect_default=" + param_multiselect_default;
    let response = await Seed.Ajax.Post({
        url: root + 'ActionEngine/index.php',
        data: send
    });
    const parsedResponse = JSON.parse(response);
    if (parsedResponse.origin === 'form') {
        handleFormUpdateResponse(parsedResponse, pImport, forceReload);
    }
    else if (parsedResponse.origin === 'list') {
        handleListUpdateResponse(parsedResponse, pImport, forceReload);
    }
    Seed.Tab.SetVisibility();
}
/**
 * Lancement d'un process PHP
 * @param {string} URL URL du ficheir PHP
 * @param {array} param Tableau de paramètre à passer au PHP
 * @param {array} paramui  Tableau de paramètre à passer au PHP
 * @param {string} type Type d'ouverture : OpenModal, window, (vide)
 * @param {string} titre Titre de la fenêtre quand le choix est OpenModal
 */
export function processPHP(URL, param, paramui, type, titre) {
    var sImport = "";
    var champRequisOk = true;
    if (param) {
        var paramLength = param.length;
        for (var i = 0; i < paramLength; i++) {
            param[i][1] = decodeParam(param[i][1]);
            sImport += "&" + param[i][0] + "=" + encodeURIComponent(param[i][1]);
        }
    }
    if (paramui) {
        var paramuiLength = paramui.length;
        for (var i = 0; i < paramuiLength; i++) {
            var uielement = $("#tab_" + Seed.Tab.cTab.attr("id"))
                .find('#' + paramui[i][1]);
            if (uielement.length === 0) {
                uielement = $("#tab_" + Seed.Tab.cTab.attr("id"))
                    .find('[id^=' + paramui[i][1] + '_]');
            }
            if (uielement.length !== 0) {
                if ((uielement.val() == "") && (paramui[i][2] == 1)) {
                    var parentGroup = $(uielement).parents('div.search-block');
                    $(parentGroup).addClass('has-error');
                    champRequisOk = false;
                }
                sImport += "&" + paramui[i][0] + "=" + encodeURIComponent(uielement.val());
            }
            else {
                alert("Element [" + paramui[i][1] + "] introuvable");
            }
        }
    }
    if (champRequisOk === false) {
        Seed.Tab.GetFrame().find('.collapse').collapse('show');
        bootbox.alert(MSG_CHAMP_REQUIS);
        return 0;
    }
    if (type === 'OpenModal') {
        URL = URL + '?' + sImport;
        openModalIframe(URL, titre);
    }
    else if (type === 'window') {
        URL = URL + '?' + sImport;
        window.location = URL;
    }
    else {
        Seed.Ajax.Post({
            url: URL,
            data: sImport,
            async: true,
            success: (response) => {
                eval(response);
            }
        });
    }
}
function cleanUpErrors(errorSpan) {
    //clean up old errors
    if (errorSpan.lastChild) {
        while (errorSpan.lastChild) {
            errorSpan.removeChild(errorSpan.lastChild);
        }
    }
}
function parseErrorMessages(errors, target, errorSpan) {
    // append new errors
    for (let errMess of errors[target]) {
        let err = document.createElement("p");
        err.innerHTML = '* ' + errMess;
        errorSpan.append(err);
    }
}
/**
 * Clean up errors in case of global form validation success
 * Might be a "better" validation too so we need to remove old errors
 */
function lookForRemainingErrorMessages(updatedFieldTargets = []) {
    let invalidFields = Seed.Tab.GetFrame().find('.is_invalid');
    if (invalidFields.length !== 0) {
        invalidFields.each(function (index, field) {
            if (updatedFieldTargets.indexOf(field.id) === -1) {
                $(field).removeClass('is_invalid');
                // look for error message
                let inputParent = $(field).parents('div[class^="col"]')[0];
                let label = $(inputParent).siblings('label')[0];
                let errorSpan = $(label).children('.error-message');
                if (errorSpan[0] !== undefined) {
                    cleanUpErrors(errorSpan[0]);
                }
            }
        });
    }
}
function addErrorCounter(errors) {
    let numberOfError = 0;
    for (let err in errors) {
        numberOfError += errors[err].length;
    }
    let globalErrorSpan = Seed.Tab.GetFrame().find('div.custom-error-block');
    if (globalErrorSpan.length === 0) {
        globalErrorSpan = Seed.Tab.GetFrame().find('div.custom-valid-block');
        $(globalErrorSpan).removeClass('custom-valid-block');
        $(globalErrorSpan).addClass('custom-error-block');
        globalErrorSpan[0].removeChild(globalErrorSpan[0].firstChild);
    }
    $(globalErrorSpan).removeClass("hidden");
    let errorCounterElement = Seed.Tab.GetFrame().find('p.error-counter')[0];
    if (errorCounterElement !== undefined) {
        errorCounterElement.remove();
    }
    let err = document.createElement("p");
    $(err).addClass('error-counter');
    err.innerHTML = 'Cette vérification a soulevé ' + numberOfError + ' erreur' + (numberOfError === 1 ? '' : 's');
    globalErrorSpan.append(err);
}
function handleListUpdateResponse(response, pImport, forceReload) {
    if (response.hasOwnProperty('errors')) {
        for (let target in response.errors) {
            kendoNotify(response.errors[target], 'danger', false);
        }
    }
    else if (response.success !== 'OK' && response.success !== 'ERR') {
        let ParamTable = [];
        if (pImport) {
            for (let i = 0; i < pImport.length; i++) {
                ParamTable.push([pImport[i][0], pImport[i][1]]);
            }
        }
        // parsedResponse.success is a numaction if we're here
        if (response.success !== 'NULL') {
            process(response.success, ParamTable, null, null);
        }
    }
    else if (response.success === 'ERR' || forceReload) {
        Seed.Tab.Reload();
        if (response.success === "ERR") {
            bootbox.alert(MSG_IMPOSSIBLE_ACTION);
        }
    }
}
function handleFormUpdateResponse(response, pImport, forceReload) {
    if (response.hasOwnProperty('errors')) {
        let hasCustom = false;
        let errorSpan;
        let updatedFieldTargets = [];
        for (let target in response.errors) {
            if (target === 'custom') {
                hasCustom = true;
                errorSpan = Seed.Tab.GetFrame().find('div.custom-error-block');
                if (errorSpan.length === 0) {
                    errorSpan = Seed.Tab.GetFrame().find('div.custom-valid-block');
                    $(errorSpan).removeClass('custom-valid-block');
                    $(errorSpan).addClass('custom-error-block');
                }
                if (errorSpan[0] !== undefined) {
                    cleanUpErrors(errorSpan[0]);
                }
                $(errorSpan).removeClass("hidden");
                parseErrorMessages(response.errors, 'custom', errorSpan);
            }
            else {
                // Handle error on simple update validation
                let input = Seed.Tab.GetFrame().find('[id^=' + target + '_]');
                updatedFieldTargets.push(input.attr('id'));
                $(input).addClass('is_invalid');
                const inputParent = input.parents('div[class^="col"]')[0];
                const label = $(inputParent).siblings('label')[0];
                errorSpan = $(label).children('.error-message')[0];
                if (errorSpan !== undefined) {
                    cleanUpErrors(errorSpan);
                    parseErrorMessages(response.errors, target, errorSpan);
                }
            }
        }
        if (response.hasOwnProperty('hasCustomOrigin') && response.hasCustomOrigin === true) {
            addErrorCounter(response.errors);
            lookForRemainingErrorMessages(updatedFieldTargets);
        }
    }
    else {
        // try to clean errors on update success
        if (response.target === 'custom') {
            const errorSpan = Seed.Tab.GetFrame().find('div.custom-error-block');
            cleanUpErrors(errorSpan[0]);
            $(errorSpan).removeClass("hidden");
            let err = document.createElement("p");
            err.innerHTML = 'Vérification effectuée sans erreur';
            errorSpan.append(err);
            $(errorSpan).removeClass("custom-error-block");
            $(errorSpan).addClass("custom-valid-block");
            lookForRemainingErrorMessages();
        }
        else {
            // Succes on simple update, remove error messages and input error class
            const input = Seed.Tab.GetFrame().find('[id^=' + response.target + '_]');
            $(input).removeClass('is_invalid');
            const inputParent = input.parents('div[class^="col"]')[0];
            const label = $(inputParent).siblings('label')[0];
            const errorSpan = $(label).children('.error-message')[0];
            if (errorSpan !== undefined && errorSpan.lastChild) {
                cleanUpErrors(errorSpan);
            }
        }
        if (response.success !== 'OK' && response.success !== 'ERR') {
            let ParamTable = [];
            if (pImport) {
                for (let i = 0; i < pImport.length; i++) {
                    ParamTable.push([pImport[i][0], pImport[i][1]]);
                }
            }
            // parsedResponse.success is a numaction if we're here
            if (response.success !== 'NULL') {
                process(response.success, ParamTable, null, null);
            }
        }
        else if (response.success === 'ERR' || forceReload) {
            Seed.Tab.Reload();
            if (response.success === "ERR") {
                bootbox.alert(MSG_IMPOSSIBLE_ACTION);
            }
        }
    }
}
//# sourceMappingURL=processLauncher.js.map